export const chapels = [
    {
      title: "Adoracja Najświętszego Sakramentu",
      events: [
        "W każdy czwartek po Mszy Świętej o godzinie 18:00 do godziny 21:00",
        "W drugi czwartek miesiąca od godziny 20:30 ze śpiewami z Taize",
      ],
    },
    {
      title: "Nowenna do Św. Urszuli Ledóchowskiej",
      events: [
        "W każdy drugi czwartek miesiąca o godzinie 17:50",
      ],
    },
    {
      title: "Nabożeństwo pierwszych sobót miesiąca",
      events: [
        "W każdą pierwszą sobotę miesiąca o godzinie 16:00",
        "W wakacje o godzinie 17:00",
      ],
    },
    {
      title: "Gorzkie żale",
      events: [
        "W Wielkim Poście w każdą niedzielę o godzinie 17:15",
      ],
    },
    {
      title: "Nabożeństwa majowe",
      events: [
        "W maju codziennie o godzinie 17:30",
      ],
    },
    {
      title: "Nabożeństwa czerwcowe",
      events: [
        "W czerwcu codziennie o godzinie 17:30",
      ],
    },
    {
      title: "Różaniec",
      events: [
        "W październiku codziennie o godzinie 17:30",
      ],
    },
  ];